export enum AuthProvider {
    PhoneNumber = 'phoneNumber',
    Facebook = 'facebook',
    Google = 'google',
    Yahoo = 'yahoo'
}
